import produce from 'immer';
import { GRID_LAYOUTS_GENERATION_STARTED, GRID_LAYOUTS_GENERATION_FAILED, GRID_LAYOUTS_GENERATION_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
const INITIAL_STATE = {
  status: 'UNINITIALIZED',
  isTaskRunning: false
};
const gridsLayoutGenerationReducer = (state = INITIAL_STATE, action) => produce(state, draft => {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case GRID_LAYOUTS_GENERATION_STARTED:
      {
        draft.gridLayoutId = payload.gridLayoutId;
        draft.status = 'IN_PROGRESS';
        draft.isTaskRunning = true;
        draft.taskId = payload.taskId;
        draft.initiatingNode = payload.nodeId;
        return draft;
      }
    case GRID_LAYOUTS_GENERATION_FAILED:
      {
        draft.status = 'FAILED';
        draft.isTaskRunning = false;
        return draft;
      }
    case GRID_LAYOUTS_GENERATION_SUCCEEDED:
      {
        draft.status = 'COMPLETE';
        draft.isTaskRunning = false;
        // TODO: figure out how to incorporate generated layout
        return draft;
      }
    default:
      {
        return draft;
      }
  }
});
export default gridsLayoutGenerationReducer;